<script setup>
import { onMounted } from 'vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()

// Initialize user on app load (handles page refreshes)
onMounted(async () => {
  await userStore.detect()
})
</script>

<template>
  <div id="app" class="container mx-auto">
    <router-view/>
  </div>
</template>
